export const noImg = "https://minio.qianj.top/iot-prod/product/no-image.jpg"
